// extracted by mini-css-extract-plugin
export default {"products":"Ex-z","card":"Fx-z","oosMessaging":"Gx-z"};